import React from "react";

import LoadingModal from "../../LoadingModal";
import ActionButtons, { ActionButtonProps } from "../ActionButtons";
import { Body, Footer, OutlinedWrapperContainer } from "./styles";

type Props = {
  children?: React.ReactNode;
  loading?: boolean;
  footer?: boolean;
  actionButtonProps?: ActionButtonProps;
};

export const OutlinedWrapper = (props: Props) => {
  const { actionButtonProps, children, loading, footer } = props;

  return (
    <>
      <OutlinedWrapperContainer>
        <Body>{children}</Body>
        {!!footer && (
          <Footer>
            <ActionButtons {...(actionButtonProps || {})} />
          </Footer>
        )}
      </OutlinedWrapperContainer>
      <LoadingModal showing={loading} />
    </>
  );
};
